/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDohItem {
  itemImage?: string;
  itemText?: string;
  itemHeading?: string;
}

export interface IDohPage extends IDohItem {
  pageHeading?: string;
  pageText?: string;
  itemList: IDohItem[];
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class BeachBall extends Component {
  private readonly dohPage: IDohPage = {
    pageHeading: 'Play-Doh Brand How To: make a beach ball',
    pageText:
      'They’re gonna have a ball with this simple Play-Doh brand project! This Play-Doh beach ball is colorful and fun—and you don’t have to inflate it at all! Just grab some blue, yellow, red and white Play-Doh cans to follow along below. This mini project is a shore hit, so ride the wave and make a beach ball in a few easy steps…it really is a breeze!',

    itemList: [
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZ4',
        itemText:
          'We’re gonna need a whole lot of blue Play-Doh compound first, so roll it up into as big a ball as they want! Next, roll two red cylinders and two yellow cylinders. Flatten each into a diamond shape as pictured.',
        itemHeading: 'beach ball parts',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsz',
        itemText:
          'Lay the yellow and red stripes on the blue Play-Doh ball. Take some white Play-Doh compound and roll two small balls with it.',
        itemHeading: 'place the stripes',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZZ3',
        itemText:
          'Flatten the two white Play-Doh balls into a circular shape. Place each where the ends of the beach ball’s stripes meet.',
        itemHeading: 'make the ends',
      },
      {
        itemImage:
          'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Xsy',
        itemText:
          'We’re sure their beach ball is a hit! Add a summer scene and place the beach ball on it, or use it as an accessory for their Play-Doh pals.',
        itemHeading: 'play ball!',
      },
    ],
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.dohPage.pageHeading}</h1>
          </div>
          <div className='col-md-12'>
            <div className='page-text'>
              <p>{this.dohPage.pageText}</p>
            </div>
          </div>
        </div>
        {this.dohPage.itemList.map((item) => (
          <div className='row'>
            <div className='col-md-12'>
              <table className='box'>
                <tr>
                  <td className='box-1'>
                    <img src={item.itemImage} alt={item.itemHeading} />
                  </td>
                  <td className='box-2'>
                    <h1 className='page-heading'>{item.itemHeading}</h1>
                    <p>{item.itemText}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default BeachBall;
